/// <amd-module name="TFS/Views/ProjectOverviewPage/Components/ProjectImage" />
import { AnimationClassNames } from "OfficeFabric/Styling";
import * as React from "react";
import { css } from "VSSUI/Util";
import { VssPersona } from "VSSUI/VssPersona";

export interface ProjectImageProps {
    projectName: string;
    projectImageUrl?: string;
}

export const ProjectImage = (props: ProjectImageProps): JSX.Element => {
    const projectImageAnimationClassName = AnimationClassNames.fadeIn400;

    return props.projectImageUrl === undefined 
    ? (
        <VssPersona
            className={css("project-persona", projectImageAnimationClassName)}
            displayName={props.projectName}
            size="large"
            suppressPersonaCard={true}
        />
    ) 
    : (
        <VssPersona
            className={css("project-persona", projectImageAnimationClassName)}
            displayName={props.projectName}
            size="large"
            suppressPersonaCard={true}
            imageUrl={props.projectImageUrl}
            />
    );
};
